import React, { Component } from 'react';
import Key from '../Key';

var Keyboard = React.createClass({

  handleClick: function(data){
    if(this.props.regexp.test(data) && this.props.autoNext){
      this.props.actionDoneNext(data);
      return;
    }
    this.props.actionSaveField(data);
  },
  render: function(){
    if(!this.props.mobile){
      return(
        <div className="keyboardWrapper">
          <div className="Keyboard letters bigButton">
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <Key actionClickButton={this.handleClick} val="ДА" />
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <Key actionClickButton={this.handleClick} val="НЕТ" />
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
          </div>
        </div>
      );
    }else{
      return(
        <div className="keyboardWrapper Numbers">
          <div className="Keyboard numbers border">
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="ДА" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="НЕТ" />
            </div>
          </div>
        </div>
      );
    }

  }
});

export default Keyboard;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/KeyboardsSwitcher/components/Boolean/index.jsx
 **/